import React from 'react';

import { Ilinha } from '.';
import {
  ButtonHorario,
  DataHorarioContainer,
  HorarioContainer,
} from './styles';

// interface IEspecialidade {
//   PerCodigo: number;
//   PerNome: string;
// }
interface props {
  horario: Ilinha[][];
  handleAgendamentoSelecionado(dados: Ilinha): void;
}

// interface IHorarioEscolhido {
//   clinica: { CliNome: string; CliEndereco: string };
//   especialidade?: IEspecialidade;
//   ConCodigo: number;
//   data: Date;
// }

const Horario: React.FC<props> = ({
  horario,
  handleAgendamentoSelecionado,
}) => {
  return (
    <>
      {horario.map(dis => (
        <div
          style={{ width: '13.4rem', flexDirection: 'column' }}
          key={`dia-${dis[0].data}`}
        >
          <DataHorarioContainer>{dis[0].dataFormatada}</DataHorarioContainer>
          <HorarioContainer>
            {dis.map(hor => (
              <ButtonHorario
                key={`hor-${hor.ConCodigo}-${hor.data}`}
                type="button"
                className="rounded-lg bg-green-600 text-white hover:scale-105 hover:bg-green-700"
                onClick={
                  () => handleAgendamentoSelecionado(hor)
                  // eslint-disable-next-line react/jsx-curly-newline
                }
              >
                {hor.hora}:{hor.minuto}
              </ButtonHorario>
            ))}
          </HorarioContainer>
        </div>
      ))}
    </>
  );
};

export default Horario;
